/**
 * L1J Web Client - Boot Scene
 * 게임 시작 시 로딩 및 초기화 씬
 */

import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    // 로딩바 표시
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    const progressBar = this.add.graphics();
    const progressBox = this.add.graphics();
    progressBox.fillStyle(0x222222, 0.8);
    progressBox.fillRect(width / 2 - 160, height / 2 - 25, 320, 50);

    this.load.on('progress', (value: number) => {
      progressBar.clear();
      progressBar.fillStyle(0xffffff, 1);
      progressBar.fillRect(width / 2 - 150, height / 2 - 15, 300 * value, 30);
    });

    // TODO: Load assets here
    // this.load.image('player', '/assets/gfx/chars/human_male.png');
  }

  create(): void {
    // 다음 씬으로 이동
    this.scene.start('LoginScene');
  }
}
